import { render, staticRenderFns } from "./VAllergenStatusIcon.vue?vue&type=template&id=6f253110&scoped=true"
import script from "./VAllergenStatusIcon.vue?vue&type=script&lang=ts"
export * from "./VAllergenStatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./VAllergenStatusIcon.vue?vue&type=style&index=0&id=6f253110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f253110",
  null
  
)

export default component.exports